import { sortContainerQueries as e } from "./index29.js";
import t from "./index32.js";
import { createEmptyBreakpointObject as n, handleBreakpoints as r, removeUnusedBreakpoints as i } from "./index33.js";
import a from "./index34.js";
import { getPath as o, getStyleValue as s } from "./index35.js";
import c from "./index44.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
function l(...e) {
	let t = e.reduce((e, t) => e.concat(Object.keys(t)), []), n = new Set(t);
	return e.every((e) => n.size === Object.keys(e).length);
}
function u(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function d() {
	function d(e, t, n, i) {
		let c = {
			[e]: t,
			theme: n
		}, l = i[e];
		if (!l) return { [e]: t };
		let { cssProperty: u = e, themeKey: d, transform: f, style: p } = l;
		if (t == null) return null;
		if (d === "typography" && t === "inherit") return { [e]: t };
		let m = o(n, d) || {};
		return p ? p(c) : r(c, t, (t) => {
			let n = s(m, f, t);
			return t === n && typeof t == "string" && (n = s(m, f, `${e}${t === "default" ? "" : a(t)}`, t)), u === !1 ? n : { [u]: n };
		});
	}
	function f(a) {
		let { sx: o, theme: s = {}, nested: p } = a || {};
		if (!o) return null;
		let m = s.unstable_sxConfig ?? c;
		function h(a) {
			let o = a;
			if (typeof a == "function") o = a(s);
			else if (typeof a != "object") return a;
			if (!o) return null;
			let c = n(s.breakpoints), h = Object.keys(c), g = c;
			return Object.keys(o).forEach((e) => {
				let n = u(o[e], s);
				if (n != null) if (typeof n == "object") if (m[e]) g = t(g, d(e, n, s, m));
				else {
					let i = r({ theme: s }, n, (t) => ({ [e]: t }));
					l(i, n) ? g[e] = f({
						sx: n,
						theme: s,
						nested: !0
					}) : g = t(g, i);
				}
				else g = t(g, d(e, n, s, m));
			}), !p && s.modularCssLayers ? { "@layer sx": e(s, i(h, g)) } : e(s, i(h, g));
		}
		return Array.isArray(o) ? o.map(h) : h(o);
	}
	return f;
}
var f = d();
f.filterProps = ["sx"];
//#endregion
export { f as default };

//# sourceMappingURL=index45.js.map